"use strict";

var _slicedToArray = require("/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useToken;

var _cssinjs = require("@ant-design/cssinjs");

var _react = _interopRequireDefault(require("react"));

var _version = _interopRequireDefault(require("../version"));

var _context = require("./context");

var _seed = _interopRequireDefault(require("./themes/seed"));

var _alias = _interopRequireDefault(require("./util/alias")); // ================================== Hook ==================================


function useToken() {
  var _react$default$useCon = _react.default.useContext(_context.DesignTokenContext),
      rootDesignToken = _react$default$useCon.token,
      hashed = _react$default$useCon.hashed,
      theme = _react$default$useCon.theme,
      components = _react$default$useCon.components;

  var salt = "".concat(_version.default, "-").concat(hashed || '');
  var mergedTheme = theme || _context.defaultTheme;

  var _ref = (0, _cssinjs.useCacheToken)(mergedTheme, [_seed.default, rootDesignToken], {
    salt: salt,
    override: Object.assign({
      override: rootDesignToken
    }, components),
    formatToken: _alias.default
  }),
      _ref2 = _slicedToArray(_ref, 2),
      token = _ref2[0],
      hashId = _ref2[1];

  return [mergedTheme, token, hashed ? hashId : ''];
}